import AddIcon from '@mui/icons-material/Add';
import { Grid, styled } from '@mui/material';
import { LwButton } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { IconTrash } from 'assets/img';
import { ConditionTimeInput } from './inputs/condition-time-input';
import { PreferredWorkerMultiSelect, WorkerOption } from './inputs/preferred-worker-multiselect';
import { PreferredWorkerFormContext } from './preferred-worker.types';

type PreferredWorkerRuleProps = {
  index: number;
  workerOptions: WorkerOption[];
  disabled?: boolean;
  handleNewRule: (index: number) => void;
  handleDelete: (index: number) => void;
};

export const PreferredWorkerRule = ({
  index,
  workerOptions,
  disabled,
  handleNewRule,
  handleDelete,
}: PreferredWorkerRuleProps) => {
  const { watch } = useFormContext<PreferredWorkerFormContext>();
  const selectedWorkerOptions = watch(`visibilityRules.${index}.workerOptions`) || [];
  const selectedTime = watch(`visibilityRules.${index}.durationCondition`) || null;

  return (
    <Grid container item xs={12}>
      <StyledGrid container item xs={12} columnSpacing={1} justifyContent={'flex-end'}>
        <Grid item xs={4}>
          <LwButton
            startIcon={<IconTrash />}
            disabled={disabled}
            color="secondary"
            onClick={() => handleDelete(index)}
          >
            Verwijderen
          </LwButton>
        </Grid>
        <Grid item xs={4}>
          <LwButton
            startIcon={<AddIcon />}
            color="primary"
            onClick={() => handleNewRule(index)}
            disabled={selectedWorkerOptions.length === 0 || !selectedTime || disabled}
          >
            Voorwaarde toevoegen
          </LwButton>
        </Grid>
      </StyledGrid>
      <Grid container item xs={24} columnSpacing={6}>
        <Grid item xs={4}>
          <ConditionTimeInput index={index} disabled={disabled} />
        </Grid>
        <Grid item xs={8}>
          <PreferredWorkerMultiSelect
            workerOptions={workerOptions}
            index={index}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));
